import api from './api';
import { liveIvrEnvironment } from './liveIvrEnvironment';

const ivrService = {
  // Same endpoint + payload shape the mobile app submits (InsuranceVerificationScreen), so a
  // record created on web is indistinguishable from one created on mobile.
  // The caller retains the random key across uncertain retries; the server reuses the original
  // IVR. Binding to the initiating login also prevents an upload/refresh race crossing accounts.
  submitIVR: (data, { idempotencyKey, sessionBinding, liveIvrConfirmed = false } = {}) => {
    if (liveIvrConfirmed && !liveIvrEnvironment().allowed)
      throw new Error('Live insurance verification is unavailable.');
    return api.post('/insurance/verify', data, {
      timeout: 90000,
      ...(idempotencyKey || liveIvrConfirmed
        ? {
            headers: {
              ...(idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {}),
              ...(liveIvrConfirmed ? { 'X-MedEffects-Live-IVR': 'confirmed' } : {}),
            },
          }
        : {}),
      ...(sessionBinding ? { sessionBinding } : {}),
    });
  },
  getIVRRequests: (params) => api.post('/ivr/search', { ...params, outcomesVersion: 2 }),
  getIVRById: (id) => api.get(`/ivr/${id}`),
  getStatusCounts: (params = {}) => api.post('/ivr/outcome-counts', params),
  updateIVR: (id, data) => api.put(`/admin/ivr/${id}`, data),
  // Removes the request from the app; it can be restored. Nothing references an IVR request.
  deleteIVR: (id) => api.delete(`/admin/ivr/${id}`),
  restoreIVR: (id) => api.post(`/admin/ivr/${id}/restore`),
};

export default ivrService;
